import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import SignupHeader from "@/components/SignupHeader"
import PlanColumns from "@/components/PlanColumns"
import PlanFrequencyToggle from "@/components/PlanFrequencyToggle"
import SignUpModal from "@/components/SignUpModal"
import Divider from "@/components/Divider"

const PricingSnapshot = ({
  title,
  description,
  discount = 0,
  frequency = "ANNUAL",
  onSelectPlan,
  onTogglePlanFrequency,
  showFrequencyToggle = false,
  className = "",
  children,
  tier,
  location,
  closeModal,
  showFreeAsColumn = true,
  showAllColumns = false,
  textClass = "",
  footerText = null,
  planButtonText,
  compareAllPlans = true,
  dividerWidth = "1240",
}) => {
  const { t } = useTranslation()

  if (!showAllColumns && discount && discount > 0) {
    showFreeAsColumn = false
  }

  // If there is no discount, don't show the frequency toggle.
  // If there is a discount but its only on monthly, the toggle will also be hidden.
  if (!discount) {
    showFrequencyToggle = false
  }

  const shouldHideUltimateColumn = !showAllColumns && showFreeAsColumn

  return (
    <>
      <Divider width={dividerWidth} />
      <div
        className={`${className} pricing-snapshot-border`}
        id="pricing-snapshot"
      >
        <SignupHeader
          title={title}
          description={description}
          onTogglePlanFrequency={onTogglePlanFrequency}
          snapshot={true}
          textClass={textClass}
          compareAllPlans={compareAllPlans}
        >
          {children}
        </SignupHeader>

        <PlanColumns
          aboveColumns={
            showFrequencyToggle ? (
              <PlanFrequencyToggle
                onChange={onTogglePlanFrequency}
                snapshot={true}
              />
            ) : null
          }
          snapshot={true}
          showFreeAsColumn={showFreeAsColumn}
          showAllColumns={showAllColumns}
          hideUltimateColumn={shouldHideUltimateColumn}
          frequency={frequency}
          onSelectPlan={onSelectPlan}
          discount={discount}
          className="plan-columns--snapshot container-fluid"
          planButtonText={planButtonText}
        />
        {footerText && (
          <p className=" center-xs p--xs col-md-4 col-md-offset-4">
            {footerText}
          </p>
        )}
      </div>

      {tier && (
        <SignUpModal
          tier={tier}
          variation="FrictionlessModal"
          title={t(`signup.modal-title.${tier}`)}
          location={location}
          frequency={frequency}
          closeModal={closeModal}
        />
      )}
    </>
  )
}

export default PricingSnapshot
